export const getIntraofficeNotesUrl = () => 'agency/intraoffice_notes';

export const getIntraofficeNoteUrl = (id: string | number) => `agency/intraoffice_notes/${id}`;
